export default __webpack_public_path__ + "static/media/edit-tas.19521a6c.svg";